export default {
  getVehicleInspection: (state) => state.vehicleInspection,
};
